export function formatPrice(number) {
    if (number - Math.floor(number) !== 0) {
        return Number(Math.round(number + "e" + 2) + "e-" + 2).toFixed(2);
    }
    return number.toFixed();
}
export function generateSlug(name){
    if(name){
       // var slug = name.toLowerCase().replace(/ /g, '-')
       //     .replace(/[^\w-]+/g, '');
        return name.toString()                   // Cast to string (optional)
            .normalize('NFKD')            // The normalize() using NFKD method returns the Unicode Normalization Form of a given string.
            .toLowerCase()                // Convert the string to lowercase letters
            .trim()                       // Remove whitespace from both sides of a string (optional)
            .replace(/\s+/g, '-')         // Replace spaces with -
            .replace(/[^\w\-]+/g, '')     // Remove all non-word chars
            .replace(/\_/g,'-')           // Replace _ with -
            .replace(/\-\-+/g, '-')       // Replace multiple - with single -
            .replace(/\-$/g, '');
    }else{
        return {}
    }


}
export const storage = {
    getToken: () => window.localStorage.getItem("token"),
    setToken: (token) =>
        window.localStorage.setItem("token", token),
    clearToken: () => window.localStorage.removeItem("token")
};
